export default __webpack_public_path__ + "static/media/Php.9932e197.png";